import { render } from "./ClientApartmentLayout.vue?vue&type=template&id=060b03c4"
import script from "./ClientApartmentLayout.vue?vue&type=script&lang=js"
export * from "./ClientApartmentLayout.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__